import styled from '@emotion/styled';

const HorizontalFieldContainer = styled.div`
    margin: 1rem 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
    input {
        flex: 1;
        margin-top: 4px;
        flex-grow: 1;
    }
`;

export default HorizontalFieldContainer;
